import axios from 'axios'
import router from '../router';
import {
    Loading,
    Message,
    MessageBox
} from "element-ui";

// 创建axios实例
const service = axios.create({
    // baseURL: process.env.BASE_API, // api的base_url
    timeout: 15000 // 请求超时时间
})
service.defaults.headers = {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
};

console.log('axios 666666666666')
service.defaults.transformResponse = [function (data) {
    try {
        data = JSON.parse(data)
    } catch (e) { }
    if (typeof data !== 'object') {
        return data
    } else {
        return data
    }
}]
// POST传参序列化
service.interceptors.request.use((config) => {
    let token = window.sessionStorage.getItem("token");
    console.log("axios -- token", token);
    if (token) {
        config.headers.Authorization = token;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})
service.interceptors.response.use(
    response => {
        const {
            data,
            config
        } = response;
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        if (response.status === 200) {
            if (data instanceof Blob) {
            return Promise.resolve(data);
            } else if (!data.success) {
                // switch (data.code) {
                //     case 500:
                //         Message({
                //             message: '请求错误或服务器异常!请联系管理员！',
                //             type: 'error'
                //         });
                //         break;
                // }
                Message({
                    message: data.errorMessage || '请求错误或服务器异常!请联系管理员！',
                    type: 'error'
                });
                return new Promise(() => { });
            } else {
                return Promise.resolve(data)
            }
        } else {
            Message({
                message: '服务器异常',
                type: 'warning'
            });
            return Promise.reject()
        }
    },
    error => {
        console.log(error)
        if (error && error.response) {
            // 1.公共错误处理
            // 2.根据响应码具体处理
            switch (error.response.status) {
                case 400:
                    error.message = '错误请求'
                    break;
                case 401:
                    // error.message = '未授权，请重新登录'
                    if (!window.sessionStorage.getItem("status_401")) {
                        window.sessionStorage.setItem("status_401", 1);
                        Message({
                            message: error.response.data.message ?
                                error.response.data.message : '登录过期，请重新登录',
                            type: 'warning'
                        });
                        // 清除token
                        setTimeout(() => {
                            router.replace({
                                path: '/'
                            });
                            window.sessionStorage.clear();
                        }, 1000);
                    }
                    break;
                case 403:
                    error.message = '拒绝访问,当前用户没有权限'
                    break;
                case 404:
                    error.message = '请求错误,未找到该资源'
                    break;
                case 405:
                    error.message = '请求方法未允许'
                    break;
                case 408:
                    error.message = '请求超时'
                    break;
                case 444:
                    Message({
                        message: error.response.data.message ?
                            error.response.data.message : '您的账号在别处登录，请确认是否本人操作',
                        type: 'warning'
                    });
                    // 清除token
                    window.sessionStorage.clear();
                    setTimeout(() => {
                        router.replace({
                            path: '/'
                        });
                    }, 1000);
                    break;
                case 500:
                    error.message = '服务器端出错'
                    break;
                case 501:
                    error.message = '网络未实现'
                    break;
                case 502:
                    error.message = '网络错误'
                    break;
                case 503:
                    error.message = '服务不可用'
                    break;
                case 504:
                    error.message = '网络超时'
                    break;
                case 505:
                    error.message = 'http版本不支持该请求'
                    break;
                default:
                    error.message = `连接错误${error.response.status}`
                    break;
            }
            Message.error(error.message);
        } else {
            // 超时处理
            if (JSON.stringify(error).includes('timeout')) {
                Message.error('服务器响应超时，请刷新当前页')
            } else {
                Message.error('连接服务器失败')
            }
        }
        // Message.error(error.message);
        return Promise.reject(error);
    }
)

export default service
